import FloatButton from "./FloatButton";

export default function SocialFloatButton() {
  return <div style={{ position: 'absolute', top: '445px', left: '1250px' }}>
    <FloatButton text="Social" />
  </div>;
}
